import { Typography } from 'antd';
import { noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import BrokerSearchModal, { BrokerSearchModalProps } from './BrokerSearchModal';
import BrokerModal from './BrokerModal';

export type BrokerForProposalType = {
  tpidbroker?: number;
  brokerreference?: string;
  brokername?: string;
  associd?: number;
};

export type BrokerInputProps = {
  onChange?: BrokerSearchModalProps['onSelect'];
  value?: BrokerForProposalType | any;
  networkcode?: string;
  role?: string;
  parentid?: number;
  isCreate?: boolean;
  onlybkid?: boolean;
  display?: boolean;
  style?: any;
  disabled?: boolean;
};

const BrokerInput = ({
  onChange = noop,
  value,
  role,
  networkcode,
  parentid,
  isCreate,
  onlybkid,
  display,
  style,
  disabled,
}: BrokerInputProps) => {
  const [Params, setParams] = useState<BrokerForProposalType>({
    tpidbroker: value?.tpidbroker,
    brokerreference: value?.brokerreference,
    brokername: value?.brokername,
    associd: value?.associd,
  });

  const { visible, close, open } = useModalState(false);
  const [tpModal, setTpModal] = useState(false);

  const handleSelect = (item: any) => {
    setParams({
      brokerreference: item?.brokerreference,
      brokername: item.brokername,
      tpidbroker: item?.tpidbroker,
      associd: item?.associd,
    });

    onlybkid ? onChange(item.tpidbroker) : onChange(item);
    close();
  };

  const hideBrokerModal = () => {
    setTpModal(true);
    close();
  };

  return (
    <>
      <div style={style}>
        {display ? (
          <Typography.Link
            onClick={() => {
              setTpModal(true);
            }}
            title="Open details"
            ellipsis
          >
            {onlybkid && !value?.tpidbroker
              ? Params?.tpidbroker
                ? `${Params.brokerreference ?? ''}  -  ${
                    Params.brokername ?? ''
                  }`
                : isCreate
                ? 'Create a Broker....'
                : 'Select a Broker'
              : value?.tpidbroker
              ? `${value.brokerreference ?? ''}  -  ${value.brokername ?? ''}`
              : isCreate
              ? 'Create a Broker....'
              : Params?.tpidbroker
              ? `${Params.brokerreference ?? ''}  -  ${Params.brokername ?? ''}`
              : 'Select a Broker'}
          </Typography.Link>
        ) : (
          <AppSearchInput
            onSearch={open}
            value={
              <Typography.Link
                onClick={() => {
                  setTpModal(true);
                }}
                title="Open details"
                ellipsis
              >
                {onlybkid && value?.tpidbroker
                  ? Params?.tpidbroker && value !== 0
                    ? `${Params.brokerreference ?? ''}  -  ${
                        Params.brokername ?? ''
                      }`
                    : isCreate
                    ? 'Create a Broker....'
                    : 'Select a Broker'
                  : value?.tpidbroker && value !== 0
                  ? `${value.brokerreference ?? ''}  -  ${
                      value.brokername ?? ''
                    }`
                  : isCreate
                  ? 'Create a Broker....'
                  : Params?.tpidbroker && value !== 0
                  ? `${Params.brokerreference ?? ''}  -  ${
                      Params.brokername ?? ''
                    }`
                  : 'Select a Broker'}
              </Typography.Link>
            }
            disabled={disabled}
          />
        )}
      </div>
      <BrokerSearchModal
        initialSearchParams={{ networkcode }} //TO DO networkcode
        visible={visible}
        onCancel={close}
        onSelect={handleSelect}
        isProposalCreate={Boolean(isCreate)}
        setBrokerForProposal={setParams}
        hideBrokerModal={hideBrokerModal}
      />
      {value?.tpidbroker || Params.tpidbroker || isCreate ? (
        <BrokerModal
          iscreate={isCreate}
          title={
            !value?.tpidbroker
              ? 'New Broker'
              : value.tpidbroker
              ? value.brokerreference ?? ' ' + value.brokername ?? ''
              : ''
          }
          tpidbroker={value?.tpidbroker}
          associd={value?.associd}
          visible={tpModal}
          onCancel={() => setTpModal(false)}
          hideBrokerModal={hideBrokerModal}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default BrokerInput;
